import React from 'react';
export function PainSection() {
  return <section className="py-6 px-4 bg-white border-t border-gray-100" data-id="element-85">
      <div className="max-w-3xl mx-auto text-center md:text-left" data-id="element-86">
        <h2 className="text-[20px] font-black mb-4 text-center text-[#EF5B4C]" data-id="element-87">
          Si sos docente, dejame hacerte una pregunta:
        </h2>

        <p className="text-xl md:text-2xl font-bold text-[#EF5B4C] mb-3 text-center" data-id="element-88">
          ¿Sentís que pasás horas buscando actividades de ESI para cada tema que
          necesitás trabajar?
        </p>

        <div className="text-lg text-gray-700 space-y-2 mb-4" data-id="element-89">
          <p data-id="element-90">
            Entre planificaciones, clases, actos, reuniones y correcciones,
            muchas veces terminás buscando recursos en distintos lugares,
            adaptando materiales o armando propuestas desde cero.
          </p>
        </div>

        <p className="text-lg text-gray-700 font-medium" data-id="element-91">
          Y cuando surge una situación en el aula, necesitás actuar rápido y no
          siempre tenés actividades listas para acompañar ese momento.
        </p>

        <p className="text-xl font-bold text-center mt-4 text-gray-900" data-id="element-92">
          La ESI no debería significar más horas de preparación.
        </p>
      </div>
    </section>;
}